var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { Emit } from "vue-property-decorator";
import { State } from "vuex-class";
import ImportCase from "~/components/case-manage/case-import/import-case.vue";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import ImportCaseDetail from "~/components/case-manage/case-import/import-case-detail.vue";
import { DataImportService } from "~/services/dataimp-service/data-import.service";
var CaseImportList = /** @class */ (function (_super) {
    __extends(CaseImportList, _super);
    function CaseImportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            principalId: "",
            batchNumber: "",
            status: "",
            type: "CASE_IMPORT" //导入类型
        };
        _this.dialog = {
            importCase: false,
            importCaseDetail: false
        };
        _this.dataSet = [];
        _this.seqNo = "";
        _this.loading = {
            state: false
        };
        return _this;
        // isShowOperate(rowData) {
        //   return (
        //     rowData.importDataExcelStatus === "IMPORT_SUCCESSFULLY" ||
        //     rowData.importDataExcelStatus === "UN_CONFIRMED"
        //   );
        // }
    }
    CaseImportList.prototype.mounted = function () {
        var _this = this;
        // 新增排序方式
        this.caseImportSortService.update("operatorTime", "descending");
        this.refreshData();
        // 收到消息通知时更新未读消息
        this.$reminder.addImportListener().subscribe(function (data) {
            if (data === "IMPORT_EXCEL_MSG" || data === "IMPORT_CONFIRMED_MSG") {
                var self = _this;
                setTimeout(function () {
                    self.refreshData();
                }, 2000);
            }
        });
    };
    CaseImportList.prototype.refreshData = function () {
        var _this = this;
        this.dataImportService
            .findAllDataImportResult(this.searchModel, this.pageService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 案件导入
     */
    CaseImportList.prototype.caseImportDialogOpen = function () {
        this.dialog.importCase = true;
    };
    /**
     * 错误信息下载
     */
    CaseImportList.prototype.errorTipsDownload = function (row) {
        var _this = this;
        this.uploadFileService
            .getFileStreamById(row.fileId)
            .subscribe(function () { return _this.$message.success("下载成功"); });
    };
    /**
     * 取消导入
     */
    CaseImportList.prototype.cancelImport = function (row) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u5BFC\u5165" + row.batchNumber + "\u6279\u6B21\u7684\u6848\u4EF6\u5417\uFF1F", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.dataImportService.cancelExcelImpCase(row.id).subscribe(function (data) {
                _this.$message.success("取消导入成功!");
                _this.refreshData();
            });
        })
            .catch(function (ex) { });
    };
    /**
     * 确认导入
     */
    CaseImportList.prototype.confirmImport = function (row) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5BFC\u5165" + row.batchNumber + "\u6279\u6B21\u7684\u6848\u4EF6\u5417\uFF1F", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            _this.loading.state = true;
            _this.dataImportService.confirmCase(row.id).subscribe(function (data) {
                _this.$message.success("正在确认请稍后!");
                _this.loading.state = false;
                _this.refreshData();
            });
        });
    };
    /**
     * 查看详情
     */
    CaseImportList.prototype.viewDetail = function (rowData) { };
    /**
     * 查看合并
     */
    CaseImportList.prototype.viewMerge = function (data) { };
    __decorate([
        Dependencies(PageService)
    ], CaseImportList.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CaseImportList.prototype, "caseImportSortService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], CaseImportList.prototype, "uploadFileService", void 0);
    __decorate([
        Dependencies(DataImportService)
    ], CaseImportList.prototype, "dataImportService", void 0);
    __decorate([
        State
    ], CaseImportList.prototype, "principalList", void 0);
    __decorate([
        Emit("onClickCaseDetail")
    ], CaseImportList.prototype, "viewDetail", null);
    __decorate([
        Emit("onClickCaseDetail")
    ], CaseImportList.prototype, "viewMerge", null);
    CaseImportList = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                ImportCase: ImportCase,
                ImportCaseDetail: ImportCaseDetail
            }
        })
    ], CaseImportList);
    return CaseImportList;
}(Vue));
export default CaseImportList;
